class MaterialCard extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector("[data-close]");
    this.inner = this.querySelector(".material-card__inner");
    this.titleEl = this.querySelector("[data-modal-title]");
    this.detailsEl = this.querySelector("[data-modal-details]");
    this.imagesEl = this.querySelector("[data-modal-images]");
    this.linkEl = this.querySelector("[data-modal-link]");

    this.handleOverlayClick = this.handleOverlayClick.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.closeEsc = this.closeEsc.bind(this);
  }

  connectedCallback() {
    if (this.closeButton) {
      this.closeButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.close();
      });
    }

    this.addEventListener("click", this.handleOverlayClick);
    document.addEventListener("material-card:open", this.handleOpen);
    document.addEventListener("material-card:close", this.handleClose);
    document.addEventListener("keydown", this.closeEsc);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleOverlayClick);
    document.removeEventListener("material-card:open", this.handleOpen);
    document.removeEventListener("material-card:close", this.handleClose);
    document.removeEventListener("keydown", this.closeEsc);
  }

  handleOverlayClick(e) {
    if (e.target.closest(".material-card__inner")) return;
    this.close();
  }

  handleOpen(e) {
    const payload = e.detail?.payload;
    if (payload) {
      this.populate(payload);
    }
    this.open();
  }

  handleClose() {
    this.close();
  }

  populate(payload) {
    const title = payload.querySelector('[data-field="title"]')?.textContent?.trim() || "";
    const details = payload.querySelector('[data-field="details"]')?.innerHTML || "";
    const collectionUrl = payload.querySelector('[data-field="collection_url"]')?.textContent?.trim() || "#";
    const images = payload.querySelector('[data-field="images"]')?.innerHTML || "";

    if (this.titleEl) this.titleEl.textContent = title;
    if (this.detailsEl) this.detailsEl.innerHTML = details;
    if (this.imagesEl) this.imagesEl.innerHTML = images;

    if (this.linkEl) {
      this.linkEl.href = collectionUrl || "#";
      this.linkEl.textContent = title ? `Shop ${title}` : "Shop";
      this.linkEl.style.display = collectionUrl && collectionUrl !== "#" ? "" : "none";
    }
  }

  closeEsc(e) {
    if (e.key === "Escape") {
      this.close();
    }
  }

  open() {
    if (this.hasAttribute("open")) return;

    this.style.display = "block";

    window.requestAnimationFrame(() => {
      this.setAttribute("open", "");
      if (window.openFullDimmer) window.openFullDimmer(this);
      if (window.lockScroll) window.lockScroll(this);
      this.returnFocusEl = document.activeElement;
      if (window.trapFocus) window.trapFocus(this, this.closeButton);
    });
  }

  close() {
    if (!this.hasAttribute("open")) return;

    this.removeAttribute("open");
    if (window.closeFullDimmer) window.closeFullDimmer(this);

    const onEnd = () => {
      this.removeEventListener("transitionend", onEnd);
      if (this.hasAttribute("open")) return;

      this.style.display = null;
      if (window.removeTrapFocus) window.removeTrapFocus(this.returnFocusEl);
      if (window.unlockScroll) window.unlockScroll(this);
    };

    this.addEventListener("transitionend", onEnd);

    setTimeout(() => {
      if (!this.hasAttribute("open")) {
        this.style.display = null;
        if (window.removeTrapFocus) window.removeTrapFocus(this.returnFocusEl);
        if (window.unlockScroll) window.unlockScroll(this);
      }
    }, 300);
  }
}

if (!customElements.get("material-card")) {
  customElements.define("material-card", MaterialCard);
}

class MaterialTrigger extends HTMLElement {
  constructor() {
    super();
    this.openButton = this.querySelector(".material-trigger");
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    if (this.openButton) {
      this.openButton.addEventListener("click", this.handleClick);
    }
  }

  disconnectedCallback() {
    if (this.openButton) {
      this.openButton.removeEventListener("click", this.handleClick);
    }
  }

  handleClick(e) {
    e.preventDefault();

    const materialId = this.openButton.dataset.materialId;
    if (!materialId) return;

    const payloadTemplate = document.querySelector(`[data-material-payload="${materialId}"]`);
    if (!payloadTemplate) return;

    const payload = payloadTemplate.content.cloneNode(true);

    document.dispatchEvent(
      new CustomEvent("material-card:open", {
        detail: {
          materialId,
          payload
        }
      })
    );
  }
}

if (!customElements.get("material-trigger")) {
  customElements.define("material-trigger", MaterialTrigger);
}